import { render, staticRenderFns } from "./companyTypeForm.vue?vue&type=template&id=7b4b4d33&%23default=true&"
import script from "./companyTypeForm.vue?vue&type=script&lang=js&"
export * from "./companyTypeForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports